import React, { useState } from "react";
import Modal from "react-bootstrap/Modal";
import { Dimmer } from "../spinner";
import useTableR from "../useTableR";
import { Input } from "../../ui/inputs/Input";
import { Mensaje } from "../mensajes2";
import axios from "axios";
export default function ModalTablaProductos(props) {
  const op = require("../../../src/modulos/datos");
  const token = localStorage.getItem("jwtToken");

  const [loading, setLoading] = useState();
  const [records, setRecords] = useState([]);
  const [selectProduct, setSelectProduct] = useState({
    id: "",
    nombre: "",
  });
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const headCells = [
    {
      id: "1",
      label: "CODIGO",
      width: "10px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
    {
      id: "2",
      label: "NOMBRE",
      width: "80px",
      textAlign: "center",
      backgroundColor: "rgba(5, 81, 130, 1)",
      fontSize: "10px",
      color: "white",
      disableSorting: true,
    },
  ];
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });
  const { TblContainer, TblHead, TblPagination, recordsAfterPagingAndSorting } =
    useTableR(records, headCells, filterFn);

  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") {
          return items;
        } else {
          return items.filter((x) => {
            if (
              x.idproducto.includes(target.value) ||
              x.descripcion.toLowerCase().includes(target.value.toLowerCase())
            ) {
              return x;
            }
          });
        }
      },
    });
  };

  const buscarProductos = async () => {
    try {
      setLoading(true);
      const campos = `idproducto, descripcion`;
      const tabla = `producto`;
      const orden = `idproducto asc`;
      const endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${tabla}&orden=${orden}`;
      const response = await axios.get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      });
      if (
        response.status === 200 &&
        response.data &&
        response.data.length > 0
      ) {
        const { data } = response;
        setRecords(data);
      }
    } catch (error) {
      setMensaje({
        mostrar: true,
        titulo: "ERROR",
        texto: "Error al Buscar los Registros",
        icono: "error",
      });
    } finally {
      setLoading(false);
    }
  };
  const aceptarProducto = () => {
    props.aceptarProductos(selectProduct);
    salir();
  };
  const blanquear = () => {
    setLoading(false);
    setSelectProduct({
      id: "",
      nombre: "",
    });
    setMensaje({
      mostrar: false,
      titulo: "",
      texto: "",
      icono: "",
    });
    setRecords([]);
  };
  const salir = () => {
    blanquear();
    props.onHiden();
  };
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
      backdrop="static"
      keyboard={false}
      onShow={() => {
        buscarProductos();
      }}
    >
      <Modal.Header className="azulGradiant px-4 py-2 text-uppercase">
        <h3 className="fs-5 fw-bold text-light m-0">Lista de Productos</h3>
        <button className="btn btn-sm bg-light" onClick={() => salir()}>
          <i className="fa fa-times"></i>
        </button>
      </Modal.Header>
      <Modal.Body>
        <div className="col-12 m-0 my-2 p-0 d-flex justify-content-between">
          <div className="col-4 m-0 p-0">
            <Input placeholder="Buscar" onChange={handleSearch} />
          </div>
        </div>
        <div className="col-12 m-0 p-0">
          <TblContainer>
            <TblHead />
            <tbody>
              {records &&
                recordsAfterPagingAndSorting().map((item, index) => (
                  <tr
                    key={index}
                    style={{
                      padding: "0",
                      cursor: "pointer",
                      background:
                        selectProduct.id === item.idproducto
                          ? "lightskyblue"
                          : "white",
                    }}
                    onClick={(e) => {
                      setSelectProduct({
                        id: item.idproducto,
                        nombre: item.descripcion,
                      });
                    }}
                  >
                    <td
                      className="align-baseline"
                      style={{ textAlign: "center", width: "10px" }}
                    >
                      {item.idproducto}
                    </td>
                    <td
                      className="align-baseline"
                      style={{ textAlign: "left", width: "auto" }}
                    >
                      {item.descripcion}
                    </td>
                  </tr>
                ))}
            </tbody>
          </TblContainer>
          <TblPagination />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <button
          className="btn-sm rounded-pill btn btn-primary col-md-3"
          onClick={() => aceptarProducto()}
        >
          <i className="fas fa-check"></i> Aceptar
        </button>

        <button
          onClick={() => salir()}
          className="btn-sm rounded-pill btn btn-danger col-md-2"
        >
          <i className="fa fa-window-close"></i> Salir
        </button>
      </Modal.Footer>
      <Mensaje
        mensaje={mensaje}
        onHide={() => {
          setMensaje({
            mostrar: false,
            titulo: "",
            texto: "",
            icono: "",
          });
        }}
      />
      <Dimmer active={loading} inverted />
    </Modal>
  );
}
